<a [href]="whatsappLink" target="_blank"
    class="{{ colors() }} disabled:bg-primary-200 text-sm whitespace-nowrap w-fit flex font-semibold uppercase px-4 py-2 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
    type="button"><i class="fab fa-whatsapp mr-2 leading-relaxed"></i>
    {{btnText()}}
</a>